import { Injectable, NgZone } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { BaseService, ConfigService, LoggingService, PITEventService } from '@pit/core';
import { ConnectionType, IPinItTrackFrontendDeviceService } from '../interfaces/pin.it.track.frontend.device.service.interface';

@Injectable({
    providedIn: 'root'
})
export class PinItTrackFrontendDeviceService extends BaseService implements IPinItTrackFrontendDeviceService {

    private _connectionType$: BehaviorSubject<ConnectionType> = null;
    private _isConnectedToNetwork$: BehaviorSubject<boolean> = null;

    constructor(configurationService: ConfigService, loggingService: LoggingService, private eventService: PITEventService, private ngZone: NgZone) {
        super(configurationService, loggingService, false);
    }

    public get connectionType(): ConnectionType {
        let result: ConnectionType = ConnectionType.None;
        /*if (this.platformType === PlatformType.App) {
            switch (this.network.type) {
                case Connection.UNKNOWN: {
                    result = ConnectionType.Unknown;
                    break;
                }
                case Connection.ETHERNET: {
                    result = ConnectionType.Ethernet;
                    break;
                }
                case Connection.WIFI: {
                    result = ConnectionType.WiFi;
                    break;
                }
                case Connection.CELL:
                case Connection.CELL_2G:
                case Connection.CELL_3G:
                case Connection.CELL_4G: {
                    result = ConnectionType.Cellular;
                    break;
                }
            }
        } else {
            if (navigator.onLine === true) {
                result = ConnectionType.Unknown;
            }
        }*/

        return result;
    }

    public get connectionType$(): BehaviorSubject<ConnectionType> {
        if (this._connectionType$ === null) {
            this._connectionType$ = new BehaviorSubject<ConnectionType>(this.connectionType);
        }

        return this._connectionType$;
    }

    public get isConnectedToNetwork(): boolean {
        let result: boolean = (this.connectionType !== ConnectionType.None);

        return result;
    }

    public get isConnectedToNetwork$(): BehaviorSubject<boolean> {
        if (this._isConnectedToNetwork$ === null) {
            this._isConnectedToNetwork$ = new BehaviorSubject<boolean>(this.isConnectedToNetwork);
        }

        return this._isConnectedToNetwork$;
    }

    public async endNetworkMonitorAsync(): Promise<void> {
        window.removeEventListener('offline', this.onOffline, false);
        window.removeEventListener('online', this.onOffline, false);

        this.handleNetworkState();
    }

    public async startNetworkMonitorAsync(): Promise<void> {
        try {
            window.addEventListener('offline', this.onOffline.bind(this), false);
            window.addEventListener('online', this.onOnline.bind(this), false);
        } catch (error) {
            this.loggingService.error(error);
        }
    }

    protected override async doInitializeAsync(): Promise<void> {
        await super.doInitializeAsync();

        if (this.isInitialized === false) {
        }
    }

    private handleNetworkState(): void {
        setTimeout(() => {
            this.ngZone.run(() => {
                if (this._connectionType$ !== null) {
                    this.connectionType$.next(this.connectionType);
                }
                if (this._isConnectedToNetwork$ !== null) {
                    this.isConnectedToNetwork$.next(this.isConnectedToNetwork);
                }

                this.loggingService.debug('App is connected to network: ' + this.isConnectedToNetwork);
                switch (this.connectionType) {
                    case ConnectionType.Cellular: {
                        this.loggingService.debug('Network connection state: Cellular');
                        break;
                    }
                    case ConnectionType.Ethernet: {
                        this.loggingService.debug('Network connection state: Ethernet');
                        break;
                    }
                    case ConnectionType.None: {
                        this.loggingService.debug('Network connection state: None');
                        break;
                    }
                    case ConnectionType.Unknown: {
                        this.loggingService.debug('Network connection state: Unknown');
                        break;
                    }
                    case ConnectionType.WiFi: {
                        this.loggingService.debug('Network connection state: WiFi');
                        break;
                    }
                }
            });
        }, 5000);
    }

    private onOffline() {
        this.ngZone.run(() => {
            this.isConnectedToNetwork$.next(false);
        });
        this.handleNetworkState();
    }

    private onOnline() {
        this.handleNetworkState();
    }

}
